<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>

    <div class="flex-grow">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/doctors/10.jpg" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">{{selectedHospitalName}}</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mx-auto mb-10 banner-container">
            <!-- Branches Section Start -->
            <div class="custom-margin py-[4em]">
                <div class="hospital-branches-sec container mx-auto">
                    <div class="custom-margin mb-[50px] box_title">
                        <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Explore Our Locations</span>
                        <h2 class="title mt-0 mb-[20px] font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] max-w-[100%] leading-[1.2em]">Our Branches</h2>
                    </div>
                    <div class="" *ngIf="branches && branches.length >0">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 relative px-[15px] mb-[30px]"
                                *ngFor="let branch of branches">
                                <div class="absolute top-[0px] right-[12px] branch-icon-container">
                                    <div
                                        class="bg-[#6eabc6] shadow text-[24px] p-[10px] rounded-full inline-block leading-1 text-center text-[#fff] branch-icon">
                                        <span
                                            class="material-symbols-outlined w-[1em] h-[1em] relative block">home_health</span>
                                    </div>
                                </div>
                                <div class="relative w-full h-full p-[45px] branch-details-container">
                                    <div class="mb-[40px] pb-[30px] branch-title">
                                        <h5 class="text-white text-[22px] font-normal m-0">{{branch.name}}</h5>
                                    </div>
                                    <div class="px-6 pb-2">
                                        <button (click)="gotoDoctorsList(branch)" class="view-doctors">
                                            View All Doctors</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container mx-auto p-10 custom-border flex justify-center items-center"  *ngIf="errors">
                        <div class="flex justify-center">
                            <h2>{{errors}}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <app-message></app-message>
    <app-footer></app-footer>
</div>